<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">来访编号</label>
            <em class="weui-form-preview__value">{{ form.main.vi_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="vi_username">
            <label class="weui-form-preview__label">{{
              customLabel.vi_username || "来访人员"
            }}</label>
            <em class="weui-form-preview__value">{{
              form.main.vi_username
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="vi_mobile">
            <label class="weui-form-preview__label">{{
              customLabel.vi_username || "手机号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.vi_mobile
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="vi_corpname">
            <label class="weui-form-preview__label">{{
              customLabel.vi_corpname || "公司名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.vi_corpname
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.vi_job" slot="vi_job">
            <label class="weui-form-preview__label">{{
              customLabel.vi_job || "职务"
            }}</label>
            <span class="weui-form-preview__value">{{ form.main.vi_job }}</span>
          </div>
          <div class="weui-form-preview__item" slot="identity">
            <label class="weui-form-preview__label">{{
              customLabel.identity || "合作身份"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.identity
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="createTime">
            <label class="weui-form-preview__label">{{
              customLabel.createTime || "申请时间"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd hh:mm'">{{ form.main.createTime }}</span>
          </div>
          <div class="weui-form-preview__item" slot="vi_reason">
            <label class="weui-form-preview__label">{{
              customLabel.vi_reason || "来访事由"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.vi_reason
            }}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.vi_text1 || '自定义字段1'" v-model="form.main.vi_text1"
            slot="vi_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.vi_text2 || '自定义字段2'" v-model="form.main.vi_text2"
            slot="vi_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.vi_text3 || '自定义字段3'" v-model="form.main.vi_text3"
            slot="vi_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.vi_text4 || '自定义字段4'" v-model="form.main.vi_text4"
            slot="vi_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.vi_text5 || '自定义字段5'" v-model="form.main.vi_text5"
            slot="vi_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">拜访公司</label>
            <span class="weui-form-preview__value">{{
              form.main.vi_obj_corpname
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">拜访对象</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{ form.main.vi_obj_name }} {{
              form.main.vi_obj_mobile }}
              <call-mobile :mobile="form.main.vi_obj_mobile"></call-mobile>
            </span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">回复状态</label>
            <span class="weui-form-preview__value">{{ form.main.status }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.vi_reply_time">
            <label class="weui-form-preview__label">回复时间</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd hh:mm'">{{ form.main.vi_reply_time }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.vi_reply_reason">
            <label class="weui-form-preview__label">拒绝理由</label>
            <span class="weui-form-preview__value">{{
              form.main.vi_reply_reason
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">扫码关注公众号，及时跟进拜访进度</label>
          </div>
          <div class="weixin_qr">
            <img src="../../assets/images/usoft_weixin_qr.png" />
          </div>
        </div>
      </div>
      <div>
        <a href="javascript:;" class="weui-btn_cell weui-btn_cell-default" @click="showList">查看全部记录</a>
      </div>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";
import CallMobile from "@/components/button/CallMobile.vue";
import CustomLayout from "@/components/layout/CustomLayout.vue";
import CustomField from "@/components/field/CustomField.vue";
import Session from '@/util/session';

export default {
  mixins: [form],
  components: {
    CallMobile,
    CustomLayout,
    CustomField
  },
  data() {
    return {
      autoLoadViewConfig: false,
      baseUrl: "/api/oa/visit_inner/visitor",
      caller: 'VisitInner',
      xtype: 'oa-visitinner-formpanel'
    };
  },
  methods: {
    showList() {
      var me = this,
        clientId = me.form.main.vi_clientid;
      me.$router.push({
        name: "OaVisitInnerVisitorList",
        params: {
          clientId: clientId,
        },
      });
    },
    f_afterload(form) {
      if (form.main.companyId) {
        Session.setScopeCompany(form.main.companyId);
        this.getViewConfig();
      }
    }
  },
};
</script>
<style scoped>
.weixin_qr img {
  width: 160px;
  height: 160px;
  display: block;
}
</style>